import { RtbCampaignListBasic } from 'core/rtbCampaign/RtbCampaign';

export type DeliveryTargetCounts = {
  total: number;
  storeChangeCount: number;
  weatherCount: number;
  overBindingLimitCount: number;
  validCount: number;
};

/**
 * 活動列表的「投遞中／原設定」統計卡與狀態文字共用這條減法。
 * 每多一個 FilterReason 就多一個要扣的欄位（ECOPD-5620 加了門市超過鎖定上限），
 * 漏扣的話「投遞中門市數」會偏高，而且看不出來。
 */
export const getDeliveryTargetCounts = (
  campaign: Pick<
    RtbCampaignListBasic,
    | 'deliveryTargetCount'
    | 'deliveryTargetChangeCount'
    | 'simulcastMismatchCount'
    | 'spaceDeletedCount'
    | 'weatherFilteredCount'
    | 'storeOverBindingLimitCount'
  >
): DeliveryTargetCounts => {
  const total = campaign.deliveryTargetCount;
  // 已刪除的門市也算門市異動：同樣是原本設定的門市現在投不出去。
  const storeChangeCount =
    campaign.deliveryTargetChangeCount +
    campaign.simulcastMismatchCount +
    campaign.spaceDeletedCount;
  const weatherCount = campaign.weatherFilteredCount;
  const overBindingLimitCount = campaign.storeOverBindingLimitCount;
  const validCount = Math.max(
    0,
    total - storeChangeCount - weatherCount - overBindingLimitCount
  );
  return {
    total,
    storeChangeCount,
    weatherCount,
    overBindingLimitCount,
    validCount
  };
};
